module.exports = __webpack_public_path__ + "static/img/14000379.02acd5d0.png";